import React from 'react';
const supportEmail = process.env.SUPPORT_EMAIL || 'tryjaca@gmail.com';

const helpTopics = [
  {
    title: 'How do I sign up?',
    content: 'Click on the Sign Up button in the menu and fill out the registration form.',
    icon: 'fas fa-user-plus',
  },
  {
    title: 'How do I become a service provider?',
    content: 'Click "Become a STEM Coach" in the top menu and complete the vendor signup process.',
    icon: 'fas fa-store',
  },
  {
    title: 'How do I book a STEM Coach?',
    content: 'Browse available services and click "Book a Provider Now" to get started.',
    icon: 'fas fa-calendar-check',
  },
  {
    title: 'How do I contact support?',
    content: (
      <>
        Email us at <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
      </>
    ),
    icon: 'fas fa-envelope',
  },
];

const HelpPage = () => {
  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Help & Support</h2>
      <div style={styles.cardGrid}>
        {helpTopics.map((topic, idx) => (
          <div key={idx} style={styles.card}>
            <div style={styles.iconCircle}>
              <i className={topic.icon} style={styles.icon}></i>
            </div>
            <h3 style={styles.cardTitle}>{topic.title}</h3>
            <div style={styles.cardContent}>{topic.content}</div>
          </div>
        ))}
      </div>
      <div style={styles.bottom}>
        <p>
          If you need further assistance, please reach out to our support team.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '900px',
    margin: '40px auto',
    padding: '32px',
    background: '#fff',
    borderRadius: '14px',
    boxShadow: '0 2px 16px rgba(0,0,0,0.10)',
  },
  title: {
    marginBottom: '32px',
    color: '#4078c0',
    fontSize: '2rem',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '1px',
  },
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '28px',
    marginBottom: '32px',
  },
  card: {
    background: '#f5f6fa',
    borderRadius: '10px',
    boxShadow: '0 1px 6px rgba(64,120,192,0.08)',
    padding: '28px 18px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '180px',
  },
  iconCircle: {
    background: '#4078c0',
    borderRadius: '50%',
    width: '48px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '14px',
  },
  icon: {
    color: '#fff',
    fontSize: '1.7rem',
  },
  cardTitle: {
    fontSize: '1.15rem',
    fontWeight: 'bold',
    color: '#8d6e36',
    marginBottom: '10px',
    marginTop: '2px',
  },
  cardContent: {
    fontSize: '1rem',
    color: '#333',
    lineHeight: '1.6',
  },
  bottom: {
    marginTop: '18px',
    textAlign: 'center',
    fontSize: '1.08rem',
    color: '#555',
  },
};

export default HelpPage;